<template>
  <ContentfulRichTextRenderer v-if="blok" :document="blok" />
</template>

<script lang="ts" setup>
import type { CMSTextProps } from '../types'
import ContentfulRichTextRenderer from '#storefront-cms/components/richText/ContentfulRichTextRenderer.vue'

defineProps<CMSTextProps>()

defineOptions({ name: 'CMSText' })
</script>
